import { ReactNode, Ref, forwardRef } from "react";

import { IconProps } from "@/components/icon";

import { Button } from "../button";

type MenuButtonProps = CommonProps & {
  text: string;
  focused: boolean;
  active: boolean;
  icon: IconProps["name"];
  iconSize?: IconProps["size"];
  disabled?: boolean;
  hideText?: boolean;
};

export const MenuButton = forwardRef<HTMLButtonElement, MenuButtonProps>(
  function MenuButton(
    {
      text,
      icon,
      iconSize,
      focused,
      active,
      disabled,
      "data-testid": dataTestId = "menuButton",
      hideText,
      className,
    }: MenuButtonProps,
    ref: Ref<HTMLButtonElement>,
  ): ReactNode {
    return (
      <Button
        text={text}
        focused={focused}
        active={active}
        disabled={disabled}
        iconLeft={icon}
        iconSize={iconSize}
        variant="secondary"
        textAlign="left"
        block
        data-testid={`${dataTestId}`}
        ref={ref}
        short
        hideText={hideText}
        typography={{ size: "h6", weight: "bold" }}
        className={className}
      />
    );
  },
);
